import { Card } from "@/components/ui/card";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { Line, LineChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";

interface TransactionAmountLineChartProps {
  transactions: any[];
}

export const TransactionAmountLineChart = ({ transactions }: TransactionAmountLineChartProps) => {
  const transactionsByDate = transactions.reduce((acc: any, transaction) => {
    const date = format(new Date(transaction.created_at), 'P', { locale: fr });
    if (!acc[date]) {
      acc[date] = {
        date,
        montant: 0,
      };
    }
    acc[date].montant += transaction.total_amount;
    return acc;
  }, {});

  const lineChartData = Object.values(transactionsByDate);

  return (
    <Card className="p-4">
      <h3 className="text-lg font-semibold mb-4">Montants par jour</h3>
      <div className="h-[300px]">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={lineChartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line
              type="monotone"
              dataKey="montant"
              stroke="#8884d8"
              name="Montant total"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
};